export default "__VITE_ASSET__24ecfe56__"